import React from 'react'
import PropTypes from 'prop-types'

import BaseCardIcon from './CardIcon.base'

const Paypal = ({ className }) => (
  <BaseCardIcon className={className} box='0 0 780 501'>
  <path d='M622.483,238.885c-4.039-3.597-9.111-5.397-15.212-5.397c-8.071,0-14.838,2.781-20.285,8.343
    c-5.454,5.561-8.18,12.382-8.18,20.446c0,6.113,1.963,10.912,5.89,14.396c3.928,3.492,9.049,5.234,15.377,5.234
    c7.853,0,14.559-2.726,20.12-8.179c5.562-5.449,8.343-12.104,8.344-19.955C628.536,247.448,626.515,242.485,622.483,238.885z'/>
  <path d='M250.826,238.885c-4.039-3.597-9.11-5.397-15.215-5.397c-8.072,0-14.835,2.781-20.283,8.343
    c-5.455,5.561-8.181,12.382-8.181,20.446c0,6.113,1.907,10.912,5.727,14.396c3.813,3.492,8.885,5.234,15.214,5.234
    c8.064,0,14.884-2.666,20.447-8.017c5.562-5.338,8.343-12.047,8.343-20.117C256.878,247.448,254.858,242.485,250.826,238.885z'/>
  <path d='M725,0H55C24.673,0,0,24.673,0,55v391c0,30.327,24.673,55,55,55h670c30.325,0,55-24.673,55-55V55
    C780,24.673,755.325,0,725,0z M120.777,257.697c-0.654,0-2.183-0.106-4.58-0.324c-2.402-0.217-4.474-0.327-6.217-0.327
    c-1.748,0-3.599,0.163-5.562,0.487c-1.963,0.326-3.6,1.04-4.907,2.13c-1.309,1.092-2.076,2.51-2.291,4.254l-5.888,35.985
    c-0.44,4.147-2.837,6.216-7.198,6.216H59.27c-1.309,0-2.401-0.543-3.271-1.636c-0.874-1.09-1.202-2.289-0.981-3.6L76.283,167.4
    c0.435-4.142,2.725-6.215,6.869-6.215h52.347c13.521,0,24.48,2.894,32.88,8.668c8.395,5.783,12.597,15.107,12.597,27.974
    c0,18.761-5.348,33.427-16.032,44.004C154.255,252.412,139.533,257.697,120.777,257.697z M295.481,214.511L282.068,299.9
    c-0.654,4.147-3.057,6.216-7.197,6.216h-22.574c-2.836,0-4.253-1.74-4.253-5.234c0-1.961,0.434-4.252,1.309-6.868
    c-3.926,4.363-9.161,7.852-15.704,10.469c-6.542,2.615-12.871,3.926-18.975,3.926c-12.652,0-22.737-3.813-30.262-11.451
    c-7.525-7.631-11.288-17.881-11.288-30.752c0-15.92,5.505-29.773,16.521-41.551c11.014-11.778,24.374-17.668,40.078-17.668
    c14.831,0,25.192,4.367,31.081,13.088c0.655-7.198,2.505-10.798,5.563-10.798h24.864c1.307,0,2.396,0.547,3.27,1.636
    C295.37,212.004,295.696,213.202,295.481,214.511z M338.342,339.814H313.15c-2.837,0-4.253-1.416-4.253-4.254
    c0-1.742,8.94-14.828,26.826-39.259c-0.219-0.866-2.78-8.505-7.688-22.897c-4.907-14.396-9.487-27.811-13.739-40.245
    c-4.252-12.432-6.379-18.863-6.379-19.303c0-1.087,0.434-2.126,1.309-3.106c0.867-0.982,1.848-1.474,2.941-1.474h24.541
    c3.704,0,6.102,1.749,7.196,5.236l14.396,49.075l34.679-51.04c1.523-2.175,3.485-3.271,5.889-3.271h25.192
    c1.087,0,2.07,0.493,2.945,1.474c0.866,0.98,1.306,2.018,1.306,3.106c0,1.097-0.218,1.857-0.652,2.29l-83.427,120.399
    C342.701,338.727,340.74,339.814,338.342,339.814z M492.432,257.697c-0.65,0-2.182-0.106-4.58-0.324
    c-2.4-0.217-4.471-0.327-6.214-0.327c-1.749,0-3.601,0.163-5.563,0.487c-1.965,0.326-3.599,1.04-4.907,2.13
    c-1.311,1.092-2.074,2.51-2.29,4.254l-5.891,37.949c-0.874,2.836-2.618,4.252-5.234,4.252h-26.826c-1.31,0-2.405-0.543-3.271-1.636
    c-0.875-1.09-1.202-2.289-0.98-3.6L447.94,167.4c0.433-4.142,2.833-6.215,7.198-6.215h52.019c13.523,0,24.481,2.894,32.879,8.668
    c8.396,5.783,12.597,15.107,12.596,27.974c0,18.761-5.345,33.427-16.031,44.004C525.91,252.412,511.191,257.697,492.432,257.697z
     M667.141,214.511L653.726,299.9c-0.653,4.147-3.056,6.216-7.194,6.216h-22.576c-2.84,0-4.254-1.74-4.254-5.234
    c0-0.866,0.215-2.178,0.655-3.926c0.433-1.744,0.655-2.724,0.655-2.942c-3.714,4.363-8.835,7.852-15.379,10.469
    c-6.543,2.615-12.978,3.926-19.301,3.926c-12.653,0-22.74-3.813-30.266-11.451c-7.523-7.631-11.285-17.881-11.285-30.752
    c0-15.92,5.505-29.773,16.521-41.551c11.011-11.778,24.373-17.668,40.077-17.668c15.052,0,25.405,4.367,31.083,13.088
    c0.653-7.198,2.503-10.798,5.558-10.798h24.866c1.309,0,2.396,0.547,3.271,1.636C667.029,212.004,667.356,213.202,667.141,214.511z
     M725.05,166.09l-21.266,133.813c-0.441,4.147-2.732,6.216-6.871,6.216h-21.595c-1.307,0-2.402-0.491-3.27-1.472
    c-0.874-0.981-1.312-2.013-1.312-3.108l0.328-0.654l21.267-136.099c0.433-2.4,1.849-3.6,4.254-3.6h24.208
    c2.833,0,4.255,1.527,4.256,4.58V166.09z'/>
  <path d='M509.774,195.044c-2.617-2.29-5.347-3.65-8.178-4.089c-2.84-0.435-6.657-0.653-11.454-0.653h-5.887
    c-2.403,0-3.82,1.2-4.252,3.597l-5.563,35.007l10.47-0.327c9.596,0,16.793-1.635,21.593-4.906c4.796-3.274,7.197-9.488,7.197-18.65
    C513.699,200.662,512.393,197.334,509.774,195.044z'/>
  <path d='M137.465,194.064c-3.926-2.504-10.255-3.761-18.975-3.761h-6.219c-2.4,0-3.817,1.2-4.252,3.597
    l-5.563,35.007l10.797-0.327c8.505,0,15.048-1.195,19.629-3.598c4.58-2.4,7.412-7.414,8.506-15.049
    C142.698,201.865,141.389,196.574,137.465,194.064z'/>
  </BaseCardIcon>
)

Paypal.propTypes = {
  className: PropTypes.string
}

export default Paypal



// WEBPACK FOOTER //
// ./src/core/icons/cards/Paypal.base.js